import { SubscriberProductPriceTierModel } from "./SubscriberProductPriceTierModel";

export class SubscriberProductPriceModel {
	id?:number = undefined;
	name: string = '';
	description: string = '';
	createdAt: Date|string = '';
	deletedAt: Date|string = '';
	minimalValue: number = 0;
	type: number = 0;
	tiers: SubscriberProductPriceTierModel[] = [];

	constructor(s?:Partial<SubscriberProductPriceModel>) {
		Object.assign(this, s);
		this._parseTiers();
	}

	private _parseTiers():void {
		this.tiers = this.tiers.map((tier) => new SubscriberProductPriceTierModel(tier))
	}
}

